import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { IconButton, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, TextField } from "@mui/material"
import { setFromEvent } from "lib/setFromEvent"
import Iconify from "minimals-template/components/Iconify"

export function Rule({ item, index }) {
    const { target, refresh } = useBoundContext()
    return (
        <ListItem>
            {item === "*" && (
                <ListItemIcon sx={{ color: "warning.main" }}>
                    <Iconify icon="mdi:warning" />
                </ListItemIcon>
            )}
            {item === "*" ? (
                <ListItemText primary={"All users, no email address restrictions"} />
            ) : (
                <TextField
                    data-cy="securityRule"
                    fullWidth
                    size="small"
                    autoFocus
                    value={item}
                    onChange={setFromEvent((v) => {
                        target[index] = v
                        refresh()
                    })}
                />
            )}

            <ListItemSecondaryAction>
                <IconButton aria-label="Remove rule" color="secondary" size="small" onClick={remove}>
                    <Iconify icon="mdi:delete" />
                </IconButton>
            </ListItemSecondaryAction>
        </ListItem>
    )

    function remove() {
        target.splice(index, 1)
        refresh()
    }
}
